import { LoginRes, MerchantData } from 'Store/user/types'

export const saveAccessToken = (accesstoken: string, expire: string) => {
  const key = 'accesstoken'
  const item = {
    value: accesstoken,
    expiry: expire,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export const removeAccessToken = () => {
  localStorage.removeItem('accesstoken')
}

export const getAccessToken = () => {
  const token = localStorage.getItem('accesstoken') || undefined
  const result = (token && JSON.parse(token)) || undefined
  const accessToken = (result && result.value) || ''
  return accessToken
}

export const clearStorage = () => {
  localStorage.clear()
}

export const saveActiveMerchant = (merchant: MerchantData): void => {
  localStorage.setItem('activeMerchant', JSON.stringify(merchant))
}

export const getActiveMerchant = (): MerchantData => {
  const merchant = localStorage.getItem('activeMerchant')
  return merchant ? JSON.parse(merchant) : ''
}

export const removeActiveMerchant = () => {
  localStorage.removeItem('activeMerchant')
}

export const saveUserLogin = (userinfo: LoginRes) => {
  const key = 'userinfo'
  const item = {
    ...userinfo,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export const removeUserLogin = () => {
  localStorage.removeItem('userinfo')
}

export const getUserLogin = (): LoginRes => {
  const userinfo = localStorage.getItem('userinfo') || undefined
  const result = (userinfo && JSON.parse(userinfo)) || undefined
  return {
    ...result,
  }
}

export const saveStaffPermission = (permission: string[]) => {
  const key = 'staff-permission'
  const item = permission
  localStorage.setItem(key, JSON.stringify(item))
}

export const removeStaffPermission = () => {
  localStorage.removeItem('staff-permission')
}

export const getStaffPermission = (): string[] => {
  const userinfo = localStorage.getItem('staff-permission') || undefined
  const result = (userinfo && JSON.parse(userinfo)) || undefined
  return result
}

export default {
  saveAccessToken,
  removeAccessToken,
  getAccessToken,

  saveActiveMerchant,
  getActiveMerchant,
  removeActiveMerchant,
  clearStorage,

  saveUserLogin,
  removeUserLogin,
  getUserLogin,
}
